import { render, staticRenderFns } from "./LContainerTitle.vue?vue&type=template&id=c36d18b0"
import script from "./LContainerTitle.vue?vue&type=script&lang=js"
export * from "./LContainerTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports